module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    staticClass: "hover-show-hidden"
  }, [(!_vm.playlist || _vm.playlist.user_id === _vm.$auth.user.id) ? _c('v-list-tile-action', {
    staticClass: "handle"
  }, [(_vm.editable && _vm.sort === 'position') ? _c('div', [_c('v-icon', {
    staticClass: "no-transition"
  }, [_vm._v("drag_indicator")]), _vm._v("\n            " + _vm._s( /** index + 1 **/ ) + "\n        ")], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "pa-1",
    staticStyle: {
      "min-width": "87px !important",
      "max-width": "87px !important"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "flat": "",
      "width": "87"
    }
  }, [_c('audio-image', {
    attrs: {
      "audio": _vm.audio,
      "height": "65px"
    }
  })], 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "list__tile__content",
    class: {
      'width-xs': _vm.$vuetify.breakpoint.xsOnly
    },
    staticStyle: {
      "text-decoration": "none",
      "color": "inherit"
    },
    attrs: {
      "to": {
        name: 'Track',
        params: {
          id: _vm.audio.id
        }
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.audio.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.audio.artist))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-list-tile-action', [(_vm.editable) ? _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('v-btn', {
    staticClass: "no-hover-opacity hidden no-transition",
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": "",
      "ripple": false
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "no-transition"
  }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": _vm.remove
    }
  }, [_c('v-list-tile-content', [_vm._v("\n                        Remove from playlist\n                    ")])], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52d89950","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PagePlaylistAudio.vue
// module id = 366
// module chunks = 0